module.exports = __webpack_public_path__ + "promotion-code.svg?a2e1f7aad4ac2a2e5906e125fceb7fc7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/promotion-code.svg
// module id = 317
// module chunks = 2